import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import PublicLayout from './components/public/PublicLayout';
import AdminLayout from './components/AdminLayout';

import Home from './pages/Home';
import Belts from './pages/Belts';
import BeltDetail from './pages/BeltDetail';
import Events from './pages/Events';
import Students from './pages/Students';
import Contact from './pages/Contact';
import History from './pages/History';
import Login from './pages/Login';

import Dashboard from './pages/admin/Dashboard';
import StudentsManagement from './pages/admin/StudentsManagement';
import BeltsManagement from './pages/admin/BeltsManagement';
import BeltContentManagement from './pages/admin/BeltContentManagement';
import EventsManagement from './pages/admin/EventsManagement';
import AdminsManagement from './pages/admin/AdminsManagement';
import ContentManagement from './pages/admin/ContentManagement';
import TariffsManagement from './pages/admin/TariffsManagement';

function App() {
  const basename = process.env.REACT_APP_BASENAME || '/';

  return (
    <ThemeProvider>
      <AuthProvider>
        <Router basename={basename}>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/belts" element={<Belts />} />
              <Route path="/belts/:id" element={<BeltDetail />} />
              <Route path="/events" element={<Events />} />
              <Route path="/students" element={<Students />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/history" element={<History />} />
              <Route path="/login" element={<Login />} />
              <Route
                path="*"
                element={
                  <div className="section-pad mx-auto max-w-content text-center">
                    <h1 className="page-title">404</h1>
                    <p className="page-lead mx-auto">Página no encontrada</p>
                    <Link to="/" className="btn-primary mt-8 inline-flex">
                      Volver al inicio
                    </Link>
                  </div>
                }
              />
            </Route>

            <Route
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/admin" element={<Dashboard />} />
              <Route path="/admin/students" element={<StudentsManagement />} />
              <Route path="/admin/belts" element={<BeltsManagement />} />
              <Route path="/admin/belts/:id/content" element={<BeltContentManagement />} />
              <Route path="/admin/events" element={<EventsManagement />} />
              <Route path="/admin/admins" element={<AdminsManagement />} />
              <Route path="/admin/content" element={<ContentManagement />} />
              <Route path="/admin/tariffs" element={<TariffsManagement />} />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
